/* eslint-disable */
<template>
  <div class="admin-referral-network">
    <AdminNavigation ref="navigation" indexProps="4" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Download Referral Network</h1></div>
        <div class="header-sub-title">Download and create a full PDF of all Active specialists in the system</div>
      </div>
    </div>
    <div class="panel">
      <AdminSpecialistMenu indexProps="2" />
      <div class="content h-100">
        <el-button type="primary" @click="getUrl">Download</el-button>
        <div v-if="user.type === 6" class="mt-16 m-auto d-flex flex-column align-items-center w-auto">

          <div class="file-upload-area border-gray-300 mt-5 mb-5 p-5" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <input
                type="file"
                name="fields[assetsFieldHandle][]"
                id="assetsFieldHandle"
                class="w-px h-px opacity-0 overflow-hidden absolute"
                @change="uploadFile"
                ref="file"
                accept=".pdf" />
            <label for="assetsFieldHandle" class="block cursor-pointer d-flex flex-column justify-content-center align-items-center">
              <div>Please drag the file，or <em>click to upload</em></div>
              <div style="font-size: 12px">Only accept PDF file</div>
            </label>
          </div>
          <el-progress v-if="uploading" style="width: 360px" class="mt-4" :percentage="percent"></el-progress>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSpecialistMenu from '@/components/AdminSpecialistMenu'
import Header from '@/components/Header'

export default {
  name: "AdminReferralNetwork",
  props: ["indexProps"],
  components: {
    AdminNavigation,
    AdminSpecialistMenu,
    Header
  },
  data() {
    return {
      percent: 0,
      uploading: false,
      fileList: [],
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    }
  },
  methods: {
    dragover(event) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains('bg-green-300')) {
      //   event.currentTarget.classList.remove('bg-gray-100')
      //   event.currentTarget.classList.add('bg-green-300')
      // }
      event.currentTarget.classList.add('dark-border-hover')
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add('bg-gray-100')
      // event.currentTarget.classList.remove('bg-green-300')
      event.currentTarget.classList.remove('dark-border-hover')
    },
    drop(event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.uploadFile() // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('bg-gray-100')
      event.currentTarget.classList.remove('bg-green-300')
      event.currentTarget.classList.remove('dark-border-hover')
    },
    async uploadFile() {
      if(!this.$refs.file.files[0].name.toLowerCase().endsWith('.pdf') ) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-error">' +
              '            <b>Error:</b> Please upload only pdf file!' +
              '          </div>',
        });
        this.$refs.file.value = ''
        return
      }

      await this.$store.dispatch("loading/setLoadComponent", true)
      const result = await utilities.postSpecialistProfiles({
        mimeType: 'application/pdf',
        fn: 'referralDoc.pdf',
      })
      let postData = new FormData()
      for (let key in result.fields) {
        postData.append(key, result.fields[key]);
      }
      postData.append('file', this.$refs.file.files[0])
      const r = await utilities.postImage(result.url, postData)
      this.$store.dispatch("loading/setLoadComponent", false)
      if(r) {
        this.onSuccess()
        this.$refs.file.value = '';
      }
    },
    onProgress(event) {
      this.percent = Number(event.percent.toFixed(0))
    },
    onSuccess() {
      this.$notify({
        dangerouslyUseHTMLString: true,
        message: '<div class="alert-success">' +
            '            <b>Success:</b> File Uploaded !' +
            '          </div>',
      });
      this.uploading = false
      this.percent = 0
    },
    async beforeUpload(file) {
      if(!file.type.includes('pdf')) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-error">' +
              '            <b>Error:</b> Please select a pdf file !' +
              '          </div>',
        });
        return Promise.reject(false)
      } else {
        const result = await utilities.checkTokenStatus()
        if(result) {
          this.percent = 0
          this.uploading = true
          return Promise.resolve(true)
        }
      }
      return Promise.reject(false)
    },
    getIdToken() {
      return utilities.getIdToken()
    },
    async getUrl(){
      this.$store.dispatch("loading/setLoadComponent", true)
      var blob = await utilities.getSpecialistProfiles()
      this.$store.dispatch("loading/setLoadComponent", false)
      if (blob) {
        var a = document.createElement('a')
        a.setAttribute('href', blob)
        // a.setAttribute('target', '_blank')
        a.setAttribute('download', 'Red Health Referral Network.pdf')
        a.click()
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      }
    },

    postFile() {

    }
  }
}
</script>
